import { SagaIterator } from "@redux-saga/core";
import { call, put, takeEvery } from "redux-saga/effects";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { migrateUserActions } from "@/App/actions";
import { MigrateUserTypes } from "@/types";

function* migrateUser(payload: MigrateUserTypes.MigrateUser): Generator {
  return yield apiService(
    {
      url: "/identity/migrate",
      method: "POST",
      data: payload,
    },
    "IAM",
  );
}

export function* migrateUserWorker(action: ReturnType<typeof migrateUserActions.migrateUser>): SagaIterator {
  const { payload } = action;
  const { migrateUserResult } = migrateUserActions;
  try {
    yield call(migrateUser, payload);
    // don't display an error, just clear the state
    yield put(migrateUserResult());
  } catch (error) {
    yield put(migrateUserResult());
  }
}

export default function* migrateUserWatcher(): SagaIterator {
  yield takeEvery(ActionTypes.MIGRATE_USER, migrateUserWorker);
}
